import React, { useEffect, useState, useRef, useMemo } from 'react'
import {Empty,Image, Button,Popover,Tooltip,Table,Tree,Layout,message,Col,Row,ConfigProvider,Tabs,Modal,} from 'antd'
import { sendHttpPostRequest } from '../../api/http-request'
import {LockOutlined,DownOutlined,UpOutlined, UndoOutlined, CaretRightOutlined, CheckOutlined, StopOutlined, TableOutlined, CodeOutlined, InfoCircleOutlined, DatabaseOutlined, FolderOpenOutlined,} from '@ant-design/icons'
import Cookies from 'js-cookie'
import logoIconSvg from '../../static/image/logo-icon.svg'
import  marked from 'marked'
//import lodingGif from '../../static/image/task/loding.gif'
import lodingGif from '../../static/image/task/robotloading.gif'

import { FileList } from '../oam/dataset/detail/FileList'
import 'easymde/dist/easymde.min.css'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../constants/constants'
import LoginRegisterModal from '../../component/modal/login-register/login-register'
import { checkIsTeacher } from '../../component/modal/login-register/login-register'
import { RouteComponentProps } from 'react-router'
import taskLearnStyles from './task-learn.module.less'
import Qs from 'qs'
import submitSuccessSvg from '../../static/image/task/submit-success.svg'
import submitFailedSvg from '../../static/image/task/submit-failed.svg'
import './task-split-pane.css'
import SplitPane from 'react-split-pane'
import MonacoEditor from 'react-monaco-editor'
import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'

import Icon from '@ant-design/icons'



import { ReactComponent as myreportSvg } from '../../static/image/my-report.svg'
import { ReactComponent as mynoteSvg } from '../../static/image/my-note.svg'
import { ReactComponent as mylightSvg } from '../../static/image/my-light.svg'
import { ReactComponent as mydescriptionSvg } from '../../static/image/my-description.svg'
import { ReactComponent as myarrowrightSvg } from '../../static/image/my-arrow-right.svg'
import { ReactComponent as myarrowleftSvg } from '../../static/image/my-arrow-left.svg'
import { ReactComponent as mydatasetSvg } from '../../static/image/mydataset.svg'
import { ReactComponent as mydatagreySvg } from '../../static/image/mydatagrey.svg'
import { ReactComponent as myboardSvg } from '../../static/image/myboard.svg'
import { ReactComponent as mymenuSvg } from '../../static/image/mymenu.svg'

import { ReactComponent as mystepsSvg } from '../../static/image/my-steps.svg'
import { ReactComponent as mycopySvg } from '../../static/image/mycopy.svg'

const myreportIcon = (props) => ( <Icon component={myreportSvg} {...props} />)
const mynoteIcon = (props) => ( <Icon component={mynoteSvg} {...props} />)
const mylightIcon = (props) => ( <Icon component={mylightSvg} {...props} />)
const mydescriptionIcon = (props) => ( <Icon component={mydescriptionSvg} {...props} />)
const myarrowrightIcon = (props) => ( <Icon component={myarrowrightSvg} {...props} />)
const myarrowleftIcon = (props) => ( <Icon component={myarrowleftSvg} {...props} />)
const mydatasetIcon = (props) => ( <Icon component={mydatasetSvg} {...props} />)
const mydatasetGreyIcon = (props) => ( <Icon component={mydatagreySvg} {...props} />)
const myboardIcon = (props) => ( <Icon component={myboardSvg} {...props} />)
const mymenuIcon = (props) => ( <Icon component={mymenuSvg} {...props} />)

const mystepsIcon = (props) => ( <Icon component={mystepsSvg} {...props} />)
const myCopyIcon = (props) => ( <Icon component={mycopySvg} {...props} />)





import { getChapterLabels } from '../common/utils/util'
import axios from 'axios'
import TooltipModal from '@/component/modal/stop-task-modal/TooltipModal'
import ModalDrag from '../components/ModaDrag/ModalDrag'
import MarkDownEditor from '../components/MarkdownEditor/MarkdownEditor'
import GlobalCss from '@/global.module.less'
import CoursePaymentModal from '../project/components/CoursePaymentModal'
import { showAccessGuideModal } from '../project/components/accessGuideModal'
import { getAccessGuideContentByReason } from '../project/components/modalCopy'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import UserInfo from '../common/user-center/user-info'

const { TabPane } = Tabs

const getAccessGuideContent = (response: any) => {
  const accessInfo = response?.access_info || {}
  const payReason = accessInfo?.pay_reason
  const content = getAccessGuideContentByReason(
    payReason,
    '当前任务不可访问，你可以加入机构，或个人付费继续使用。'
  )
  return {
    content,
    accessInfo,
  }
}

const TSplitPane: any = SplitPane

// 通过路由组件额外添加参数信息到表中
interface Props extends RouteComponentProps<{ task_id: string }> {
  task_id: string
}

export const TaskLearn: React.FC<Props> = (props) => {
  const _location = props.location.search.includes('?')
    ? props.location.search.split('?')[1].split('/')
    : null
  const [theChapterId, setTheChapterId] = useState(0) //当前实训任务ID

  let projectId = 1 // 项目ID
  let chapterId = 3 // 章ID
  let exerciseId = 14 // 节ID
  if (_location && _location.length >= 6) {
    projectId = parseInt(_location[1])
    chapterId = parseInt(_location[3])
    exerciseId = parseInt(_location[5])
  } else {
    history.replaceState(
      null,
      '',
      `task_learn?project/${projectId}/chapter/${chapterId}/task/${exerciseId}/`
    )
  }


  
  const monacoEditorRef = useRef(null)
  const [running, setRunning] = useState(false) // 运行中状态
  const [testRunning, setTestRunning] = useState(false) // 测试运行中状态
  const [stoping, setStoping] = useState(false) // 运行中状态
  const [currentStatus, setCurrentStatus] = useState(null as any)
  const [outputs, setOutputs] = useState(null as any) //运行的输出结果
  const [variables, setVariables] = useState(null as any) //运行的输出变量列表
  const [submitTime, setSubmitTime] = useState('') //运行时间
  const [submitStatus, setSubmitStatus] = useState(false) //运行状态
  const [submitImages, setSubmitImages] = useState([]) //运行结果图
 
  const specialTreatment = useRef(false)
  const submitState = useRef(0)
  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeName, setCollegeName] = useState(null as any) // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，

  const [notes, setNotes] = useState(null as any) //用户笔记
  const [menu, setMenu] = useState(null as any) //项目大纲
  const [courseAccessInfo, setCourseAccessInfo] = useState(null as any)
  const [coursePaymentVisible, setCoursePaymentVisible] = useState(false)
  const [pendingAccessInfo, setPendingAccessInfo] = useState(null as any)
  const [task, setTask] = useState(null as any) //当前实训任务
  const taskId = useRef(exerciseId) //当前实训任务ID
  const [project, setProject] = useState(null as any)
  const [report, setReport] = useState(null as any) //项目的报告



  const [outputIsFullScreen, setOutputIsFullScreen] = useState(false) //记录运行结果区域是否处于全屏状态
  const [outputHeight, setOutputHeight] = useState(300) //结果区域的高度

  const [correctTaskNum, setCorrectTaskNum] = useState(0) //通过的任务数
  const [wrongTaskNum, setWrongTaskNum] = useState(0) //未过的任务数
  const [unsubmitTaskNum, setUnsubmitTaskNum] = useState(0) //未提交的任务数
  const [submitMode, setSubmitMode] = useState(null as any) // 提交方式 1-运行 2-提交

  const [menuSelected, setMenuSelected] = useState(false)
  const [fullscreenSelected, setFullscreenSelected] = useState(false)

  const [verticalPane1Height, setVerticalPane1Height] = useState(
    document.body.clientHeight / 2 - 35
  ) 

  const [tooltipopen, setTooltipopen] = useState(false)
  const [multipleRunModalVis, setMultipleRunModalVis] = useState(false)
  const [stopedByOtherVis, setStopedByOtherVis] = useState(false)
  const [stopedMsg, setStopedMsg] = useState('')
  const [taskStatus, setTaskStatus] = useState(100)//条
  const [roleTeacher, setRoleTeacher] = useState(false)

  const shouldUseTeacherMode = (accessInfo?: any) => {
    const payReason =
      accessInfo?.pay_reason ||
      courseAccessInfo?.pay_reason ||
      project?.access_info?.pay_reason
    return collegeInfo?.is_college_teacher == 1 && payReason === 'teacher_bypass'
  }


  // 任务数据集相关变量
  const [datasetActiveTabKey, setDatasetActiveTabKey] = useState('taskdata')
  const [taskDatasetInfo, setTaskDatasetInfo] = useState<any>()
  const [activeMountedDatasetInfo, setActiveMountedDatasetInfo] = useState<any>(
    task?.mounted_datasets[0]
  )


  /**
 * 将时间字符串转换为人类易理解的时间表述
 * @param {string} timeStr - 时间字符串（支持ISO格式如'2025-09-03T12:00:00'或普通格式如'2025/09/03 12:00:00'）
 * @returns {string} 人类易理解的时间表述（30秒内'刚刚'、30秒-1小时'X秒/分钟前'、1小时以上显示具体时间）
 */
function formatTimeToHumanReadable(timeStr) {
    // 处理时间字符串，转换为时间戳（兼容多种格式）
    const targetTime = new Date(timeStr).getTime();
    const targetDate = new Date(timeStr);
    const currentTime = new Date().getTime();
    
    // 校验时间字符串是否有效
    if (isNaN(targetTime)) {
        return '无效的时间格式';
    }
    
    // 计算时间差（毫秒），取绝对值确保处理过去和未来时间
    const timeDiff = Math.abs(currentTime - targetTime);
    
    // 定义时间单位换算（毫秒）
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    
    // 1小时内显示相对时间，1小时以上显示具体时间（格式：YYYY-MM-DD HH:MM）
    if (timeDiff < 30 * second) { // 30秒内
        return '刚刚';
    } else if (timeDiff < minute) { // 30秒-1分钟
        return `${Math.floor(timeDiff / second)}秒前`;
    } else if (timeDiff < hour) { // 1分钟-1小时
        return `${Math.floor(timeDiff / minute)}分钟前`;
    } else { // 1小时以上，显示具体时间（补零处理，确保格式统一）
        //const year = targetDate.getFullYear();
        const month = String(targetDate.getMonth() + 1).padStart(2, '0');
        const day = String(targetDate.getDate()).padStart(2, '0');
        const hours = String(targetDate.getHours()).padStart(2, '0');
        const minutes = String(targetDate.getMinutes()).padStart(2, '0');
        return  timeStr;//`${year}-${month}-${day} ${hours}:${minutes}`;
    }
}

  const getMenuTreeContent = () => { //菜单
    return             <div
    className={taskLearnStyles.menuWrapper}

    style={{maxHeight:600, overflow:'auto'}}

  >
    <div className={taskLearnStyles.menuTree}>
      <Tree
        switcherIcon={<DownOutlined />}
        showIcon={true}
        selectedKeys={['task_' + taskId.current]}
        blockNode={true}
        treeData={getTreeData()}
        defaultExpandAll={true}
        onSelect={handleTaskSelected.bind(this)}
        titleRender={(nodeData) => {
          if (
            nodeData.selectable == false  // 目录
          ) {
            return (
              <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
                {' '}
                <Col flex={'200px'} style={{ paddingLeft: 0 }}>
                  {' '}
                  <span style={{fontWeight:500,display: 'inline-block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", maxWidth:210}}> {nodeData.title} </span>
                </Col>{' '}
              </Row>
            )
          } else if ((nodeData as any).pay_locked == 1) {
            return (
              <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
                <Col flex={'200px'} style={{ paddingLeft: 0, color: '#999' }}>
                  <span style={{display: 'inline-block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", width:210}}>
                    <LockOutlined style={{ marginRight: 6 }} />
                    {nodeData.title}
                  </span>
                </Col>
              </Row>
            )
          } else if (
            String(nodeData.key).indexOf('task') >= 0 && // 任务通过了
            (nodeData as any).status == 2
          ) {
            return (
              <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
                {' '}
                <Col flex={'100px'} style={{ paddingLeft: 0 }}>
                  <span style={{display: 'inline-block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", width:210}}> 
                  <span className= {taskLearnStyles.taskCompleteSpan}  />
                    {nodeData.title} </span>
                    <span style={{display: 'inline-block'}} >{nodeData?.have_dataset == true &&  <Icon
                            component={mydatasetGreyIcon}
                            style={{
                              display: 'inline-block', 
                              verticalAlign: 'top',
                              //width: 20,
                              //height: 20,
                              //color: '#fff',
                            }}
                          />
                      }</span>
                </Col>

              </Row>
            )
          } else {  // 任务没通过
            return (

            <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
              {' '}
              <Col flex={'200px'} style={{ paddingLeft: 0 }}>

                <span style={{display: 'inline-block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", width:210}}> 
                <span className= {taskLearnStyles.taskUncompleteSpan}  />
                  {nodeData.title} </span>
                  <span style={{display: 'inline-block'}} >{nodeData?.have_dataset == true &&  <Icon
                            component={mydatasetGreyIcon}
                            style={{
                              display: 'inline-block', 
                              verticalAlign: 'top',
                              //width: 20,
                              //height: 20,
                              //color: '#fff',
                            }}
                          />
                      }</span>
              </Col>{' '}
            </Row>


            )
          }
        }}
       // style={{ color: '#f2f2f2' }}
      ></Tree>
    </div>
  </div>
  }





  const checkSubmitRecord = () => {
    console.log(roleTeacher)

    if (roleTeacher) {
      window.open(
        'project_main?project_id=' + projectId + '/?key=my_commit_record'
      )
    } else {
      window.open(
        '/project_main_student?project_id=' +
          projectId +
          '/?key=my_commit_record'
      )
    }
  }

  const onStopTaskOk = () => {
    setStoping(true)
    let data = {
      source: 1, //1 我的   2 学生
      exercise_id: taskId.current,
    }
    sendHttpPostRequest(
      'exercise/api/running_exercise_interrupt',
      data,
      (res) => {
        if (res.code == 0) {
          setTimeout(() => {
            setStoping(false)
            message.success('停止成功~')
            setTaskStatus(4) //TODO 刚停止就不要显示正误了
          }, 2000)
          clearInterval(timer)
          clearInterval(checkStatusTimer.current)
          clearInterval(animationTimer.current)
          setRunning(false)
          setTestRunning(false)
        } else {
          setStoping(false)
          message.error(res.msg)
        }
      }
    )
    setTooltipopen(false)
  }

  let timer //  query_task_info 轮询
  const animationTimer = useRef<any>()
  const checkStatusTimer = useRef<any>()

  const checkRunningStatus = (exercise_submit_id) => {
    let data = {
      exercise_submit_id,
    }
    sendHttpPostRequest('exercise/api/exercise_running_status', data, (res) => {
      if (res.code == 0) {
        if (res.data.status == 4) {
          setStopedByOtherVis(true)
          setStopedMsg(res.msg)
          clearInterval(checkStatusTimer.current)
        } else if (res.data.status != 1) {
          clearInterval(checkStatusTimer.current)
        }
      } else {
        clearInterval(checkStatusTimer.current)
        clearInterval(timer)
        setRunning(false)
        setTestRunning(false)
      }
    })
  }

  const refresh_table_tds = ()=>{
    setTimeout(function(){
      const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
      console.log(table_tds)
      for(let i=0; i < table_tds.length;  i++){
          try{
            console.log(table_tds[i].innerText)
            table_tds[i].setAttribute('title', table_tds[i].innerText);
          }catch(error1){
            console.log(error1)
          }
        }
    }, 1000); //单位是毫秒

  }

  useEffect(() => {
    window.onload = function(){
      try{
        refresh_table_tds()
      }catch(error){
        console.log(error)
      }
    } 


    sendHttpPostRequest(
      //获取院校身份信息
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          const hasCollege = response?.college_id !== 0
          if (hasCollege) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            setCollegeInfo(response.college_info)
            setCollegeName(response.college_info.college_name)
            setRoleTeacher(response.college_info.is_college_teacher == 1)
          } else {
            setCollegeId(0)
            setCollegeInfo(null)
            setCollegeName('')
            setRoleTeacher(false)
          }

          queryProject()
          queryMenu(projectId, false, (_menuData, accessInfo) => {
            const teacherMode =
              hasCollege &&
              response.college_info.is_college_teacher == 1 &&
              accessInfo?.pay_reason === 'teacher_bypass'
            setRoleTeacher(teacherMode)
            getTaskStatus(teacherMode)
              .then((res) => {
                message.destroy()
                if (res.code == -100) {
                  // 未登录
                  document.getElementById('show-login-modal')!.click()
                } else if (res.is_ok) {
                  setTask(res.exercise_info)
                  setTaskStatus(
                    res.exercise_info.submission_info.submission_status
                  )

                  
                  if (res.exercise_info?.submission_info?.submission_code != '')
                    setUserCode(
                      res.exercise_info.submission_info.submission_code
                    )
                  else {
                    setUserCode(res.exercise_info.default_code)
                  }


                  setTheChapterId(chapterId)
                  setRunning(false)
                  setTestRunning(false)
                  
                  if (res.exercise_info.submission_info) {
                    submitState.current =res.exercise_info.submission_info.submission_status
                    setSubmitMode(res.exercise_info.submission_info.submit_mode)//TODO
                    // 习题正误结果显示
                    if (
                      1 == res.exercise_info.submission_info.submission_status
                    ) {
                      checkStatusTimer.current = setInterval(() => {
                        checkRunningStatus(
                          res.exercise_info.submission_info.exercise_submit_id
                        )
                      }, 1000)
                    } else if (
                      2 == res.exercise_info.submission_info.submission_status
                    ) {
                      setSubmitStatus(true)
                      setCurrentStatus(true)
                      //setSubmitMode(2)
                      clearInterval(checkStatusTimer.current)
                    } else if (
                      3 == res.exercise_info.submission_info.submission_status
                    ) {
                      setSubmitStatus(true)
                      setCurrentStatus(false)
                      //setSubmitMode(2)
                      clearInterval(checkStatusTimer.current)
                    } else if (
                      4 == res.exercise_info.submission_info.submission_status
                    ) {
                      clearInterval(checkStatusTimer.current)
                    }
                  } else {
                    setSubmitMode(1)
                    setVariables('')
                  }
                  if (submitState.current == 1) {
                    if (res.exercise_info.submission_info.submit_mode == 1) {
                      setTestRunning(true)
                    } else {
                      setRunning(true)
                    }
                    timer = setInterval(() => {
                      queryTaskInfo(teacherMode)
                    }, 5000)
                  } else {
                    setRunning(false)
                    clearInterval(timer)
                    clearInterval(checkStatusTimer.current)
                    queryTaskCallback(res)
                  }
                }
              })
          })
          queryUserTaskNote() //查询用户笔记
        }
      }
    )

  }, [])



  const getTaskStatus = (isTeacher) => {
    const _headers = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
    const url = 'exercise/api/query_task_by_id/'
    let params = {
      exercise_id: taskId.current,
      sessionid: Cookies.get('sessionid'),
    }
    if (isTeacher) {
      params['mode'] = 2
    }
    const _data = Qs.stringify(params)
    return axios
      .post(constants.BACKEND_API_URL + url, _data, _headers)
      .then((res) => res.data)
  }

  const onVerticalPane1Change = (height: any) => {
    setVerticalPane1Height(height)
  }



  // 查询任务详情
  const queryTaskInfo = (isTeacher) => {
    let params = {
      exercise_id: taskId.current,
      sessionid: Cookies.get('sessionid'),
    }
    if (isTeacher) {
      params['mode'] = 2
    }
    sendHttpPostRequest(
      'exercise/api/query_task_by_id/',
      params,
      queryTaskCallback
    )
  }

  const specialTreatmentfun = (responseOutPut) => {
    let tb_startInd = responseOutPut.indexOf('+--')
    let tb_endInd = responseOutPut.lastIndexOf('--+') + 3
    let pre_str = responseOutPut.substr(0, tb_startInd)
    let nex_str = responseOutPut.substr(tb_endInd)

    let prepare_marked = responseOutPut.slice(tb_startInd, tb_endInd)

    let tbarr = prepare_marked.split('|')
    tbarr.shift()
    tbarr.pop()
    let tbstr = tbarr.join('|')
    for (let i = 0; i < tbstr.length; i++) {
      if (
        (tbstr[i] === '+' && tbstr[i + 1] === '-' && tbstr[i + 2] === '-') ||
        (tbstr[i] === '+' && tbstr[i - 1] === '-' && tbstr[i - 2] === '-')
      ) {
        tbstr = tbstr.replace(tbstr[i], '|')
      }
    }
    let marktable = marked.parse(tbstr)
    setOutputs(pre_str + marktable + nex_str)
  }


    // 查询任务数据集详情
    const queryTaskDatasetInfo = (datasetId?: any) => {
      let data = {
        dataset_id: datasetId || task?.dataset_id,
      }
      sendHttpPostRequest('dataset/api/user_get_dataset_by_id/', data, (res) => {
        if (res.code == 0) {
          setTaskDatasetInfo(res.query_info)
        } else {
          message.error(res.message)
        }
      })
    }

  const queryTaskCallback = (response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == -4201) {
      showAccessGuide(response)
    } else if (response.is_ok == true) {
      // 成功
      setTask(response.exercise_info)

      queryTaskDatasetInfo(response.exercise_info?.dataset_id)
      setUserCode(response.exercise_info.default_code)
      setRunning(false)
      setTestRunning(false)
      setTaskStatus(response.exercise_info.submission_info.submission_status)
      setIsAnimation(response.exercise_info.submission_info.is_animation)
      if (response.exercise_info.submission_info) {
        setSubmitMode(response.exercise_info.submission_info.submit_mode)
        //如果结果则更新运行信息
        submitState.current = response.exercise_info.submission_info.submission_status

        setTaskStatus( response.exercise_info.submission_info.submission_status)
        
        if (submitState.current == 1) {
          checkStatusTimer.current = setInterval(() => {
            checkRunningStatus(
              response.exercise_info.submission_info.exercise_submit_id
            )
          }, 1000)
          if (response.exercise_info.submission_info.submit_mode == 1) {
            setTestRunning(true)
          } else {
            setRunning(true)
          }
        } else {
          setRunning(false)
          setTestRunning(false)
          clearInterval(timer)
          clearInterval(animationTimer.current)
        }
        if (response.exercise_info.submission_info.is_html) {
          setUserImage(response.exercise_info.submission_info.submission_output)
          setUserImageJs(response.exercise_info.submission_info.js_script)
          setOutputs('')
          eval(response.exercise_info.submission_info.js_script)
        } else if (
          response.exercise_info.submission_info.submission_output &&
          response.exercise_info.submission_info.submission_output != '' &&
          response.exercise_info.submission_info.submission_output.indexOf(
            '+--'
          ) >= 0 &&
          response.exercise_info.submission_info.submission_output.lastIndexOf(
            '--+'
          ) >= 0
        ) {
          specialTreatment.current = true
          setUserImage('')
          setUserImageJs('')
          try {
            specialTreatmentfun(
              response.exercise_info.submission_info.submission_output
            )
          } catch (e) {
            console.error(e)
          }
        } else {
          specialTreatment.current = false
          setUserImage('')
          setUserImageJs('')
          setOutputs(response.exercise_info.submission_info.submission_output)
        }

        if (response.exercise_info.submission_info.submission_code != '')
          setUserCode(response.exercise_info.submission_info.submission_code)
        if (response.exercise_info.submission_info.submission_variables != '')
          setVariables(
            response.exercise_info.submission_info.submission_variables
          )
        if (response.exercise_info.submission_info.submission_time != '')
          setSubmitTime(response.exercise_info.submission_info.submission_time)
        if (response.exercise_info.submission_info.submission_image) {
          setSubmitImages(
            response.exercise_info.submission_info.submission_image
          )
          if (response.exercise_info.submission_info.is_animation) {
            clearInterval(animationTimer.current)
            let imgs = response.exercise_info.submission_info.submission_image
            let n = 0
            animationTimer.current = setInterval(function () {
              let imgContain: any =
                document.getElementById('animation_img') &&
                document.getElementById('animation_img')
              if (imgContain) {
                imgContain.src = 'data:image/jpg;base64,' + imgs[n]
                n = n + 1
                if (n >= imgs.length) {
                  n = 0
                }
              }
            }, 100)
          }
        }

        if (2 == response.exercise_info.submission_info.submission_status) {
          setSubmitStatus(true)
          setCurrentStatus(true)
          //setSubmitMode(2)
          clearInterval(checkStatusTimer.current)
        } else if (
          3 == response.exercise_info.submission_info.submission_status
        ) {
          setSubmitStatus(true)
          setCurrentStatus(false)
          //setSubmitMode(2)
          clearInterval(checkStatusTimer.current)
        } else {
          //setSubmitMode(1)
          setVariables('')
        }
      } else {
        //如果没有运行结果，则清空运行信息
        setOutputs(null as any)
        setSubmitImages([] as any)
        setVariables(null as any)
        setSubmitMode(1)
        setVariables('')
      }
      setTheChapterId(chapterId)
      history.replaceState(
        null,
        '',
        `task_learn?project/${projectId}/chapter/${chapterId}/task/${response.exercise_info.id}/`
      )
    } else {
      message.error(response.message)
    }
  }

  // 查询用户任务笔记
  const queryUserTaskNote = () => {
    sendHttpPostRequest(
      'course/api/query_note',
      {
        exercise_id: taskId.current,
        chapter_id: chapterId,
        sessionid: Cookies.get('sessionid'),
      },
      queryUserTaskNoteCallback
    )
  }

  // 查询项目的报告目录
  const queryProjectReport = (reportId) => {
    sendHttpPostRequest(
      'report/api/user_query_report',
      { report_id: reportId, sessionid: Cookies.get('sessionid') },
      (response) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功
          setReport(response.query_info)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const checkTaskInRepot = (task_id) => {
    let taskIn = false
    report?.json?.map((chapter) => {
      chapter?.tasks?.map((item) => {
        if (item.exercise_id == taskId.current) {
          taskIn = true
        }
      })
    })
    return taskIn
  }

  const queryUserTaskNoteCallback = (response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // 成功
      setNotes(response.content)
    }else {
      message.error(response.message)
    }
  }

  // 保存用户任务笔记
  const save_note = () => {
    sendHttpPostRequest(
      'course/api/save_note',
      {
        exercise_id: taskId.current,
        chapter_id: chapterId,
        content: notes,
        sessionid: Cookies.get('sessionid'),
      },
      saveUserTaskNoteCallback
    )
  }

  const saveUserTaskNoteCallback = (response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // message.success('保存成功~')
      // 成功
      // setNotes(response.content)
    } else {
      message.error(response.message)
    }
  }

  /**
   * 查询项目
   */
  const queryProject = () => {
    console.log(111)
    sendHttpPostRequest(
      'course/api/query_project_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
      },
      queryProjectCallback
    )
  }

  /**
   * 查询项目回调
   * @param response
   */
  const queryProjectCallback = (response: any) => {
    // console.log(response)
    console.log(112, response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // 成功
      setProject(response.query_info)
      if (response.query_info.report_id > 0) {
        queryProjectReport(response.query_info.report_id)
      }
    } else {
      message.error(response.message)
    }
  }

  const queryMenu = (
    project_id: string | number,
    showModal: boolean,
    onSuccess?: (menuData: any[], accessInfo?: any) => void
  ) => {
    sendHttpPostRequest(
      'course/api/query_course_submission',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: project_id,
      },
      (response: any) => {
        // console.log(response)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功
          setMenu(response.menu)
          setCourseAccessInfo(response.access_info)

          let rightSum = 0
          let wrongSum = 0
          let unsumbitSum = 0

          response.menu?.map((chapter) => {
            chapter.tasks.map((task) => {
              if (task.status == 2) {
                rightSum = rightSum + 1
              } else if (task.status == 1) {
                wrongSum = wrongSum + 1
              } else {
                unsumbitSum = unsumbitSum + 1
              }
            })
          })

          setCorrectTaskNum(rightSum)
          setWrongTaskNum(wrongSum)
          setUnsubmitTaskNum(unsumbitSum)
          if (onSuccess) {
            onSuccess(response.menu || [], response.access_info || {})
          }
          if (showModal) {
            if (projectStatusContentVisible == false) {
              //setProjectStatusContentVisible(true)
              //setFullscreenSelected(true)
            } else {
              //setProjectStatusContentVisible(false)
              //setFullscreenSelected(false)
            }
          }
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /** 将大纲转成菜单控件的输入格式 */
  const getTreeData = () => {
    const treeData = [] as any[] //
    menu?.map((chapter, chapterInd) => {
      const treeChapter = {
        key: 'chapter_' + chapter.id,
        title: getChapterLabels(chapterInd) + ' ' + chapter.name,
        selectable: false,
        status: chapter.status,
        is_pass: chapter.is_pass,
        children: [] as any[],
      }

      chapter.tasks?.map((task, taskInd) => {
        treeChapter.children.push({
          key: 'task_' + task.id,
          title:
            String(chapterInd + 1) +
            '.' +
            String(taskInd + 1) +
            ' ' +
            task.name,
          chapterId: chapter.id,
          status: task.status,
          have_dataset: task.have_dataset,
          pay_locked: task.pay_locked,
          selectable: true,
        })
      })

      treeData.push(treeChapter)
    })
    return treeData
  }

  // 判断当前任务是否是第一个/最后一个
  const isFirstTask = useMemo(() => {
    if (!menu || menu.length === 0) return true
    const firstChapter = menu[0]
    if (!firstChapter?.tasks || firstChapter.tasks.length === 0) return true
    return theChapterId === firstChapter.id && taskId.current === firstChapter.tasks[0].id
  }, [menu, theChapterId, taskId.current])

  const isLastTask = useMemo(() => {
    if (!menu || menu.length === 0) return true
    const lastChapter = menu[menu.length - 1]
    if (!lastChapter?.tasks || lastChapter.tasks.length === 0) return true
    return theChapterId === lastChapter.id && taskId.current === lastChapter.tasks[lastChapter.tasks.length - 1].id
  }, [menu, theChapterId, taskId.current])

  const [menuVisible, setMenuVisible] = useState(false) //项目大纲弹出框是否可见
  const [isHtml, setIsHtml] = useState(false) //项目大纲弹出框是否可见
  const [isAnimation, setIsAnimation] = useState(false) //项目大纲弹出框是否可见
  const [currentActiveTabKey, setCurrentActiveTabKey] = useState('1') //1 描述 2笔记 ，3答案
  const [currentOutputActiveTabKey, setCurrentOutputActiveTabKey] = useState('outputs') //1 运行结果 
  const [userCode, setUserCode] = useState('' as any) //
  const [userImage, setUserImage] = useState(null as any) //
  const [userImageJs, setUserImageJs] = useState(null as any) //
  const [noteEditMode, setNoteEditMode] = useState(true) //笔记是否处于编辑模式

  const [projectStatusContentVisible,setProjectStatusContentVisible] = useState(false) //是否显示个人实训项目完成状态
  const [datasetContentVisible, setDatasetContentVisible] = useState(false) //是否显示任务数据集内容

  const showAccessGuide = (response: any) => {
    const { content, accessInfo } = getAccessGuideContent(response)
    setPendingAccessInfo({
      ...(accessInfo || {}),
      target_task_id: response?.target_task_id,
      target_chapter_id: response?.target_chapter_id,
    })
    showAccessGuideModal({
      accessInfo,
      content,
      onPersonalPay: () => {
        setCoursePaymentVisible(true)
      },
    })
  }

  const pickTaskAfterPayment = (menuData: any[]) => {
    if (!menuData || menuData.length == 0) {
      return null
    }

    const wantedTaskId = parseInt(String(pendingAccessInfo?.target_task_id || taskId.current || 0))
    const wantedChapterId = parseInt(String(pendingAccessInfo?.target_chapter_id || chapterId || 0))

    let fallback = null as any
    let matchedUnlocked = null as any

    menuData.forEach((chapter) => {
      chapter?.tasks?.forEach((item) => {
        if (!fallback && item?.pay_locked != 1) {
          fallback = {
            chapterId: chapter.id,
            taskId: item.id,
          }
        }
        if (
          item?.id == wantedTaskId &&
          item?.pay_locked != 1
        ) {
          matchedUnlocked = {
            chapterId: wantedChapterId || chapter.id,
            taskId: item.id,
          }
        }
      })
    })

    return matchedUnlocked || fallback
  }

  const onCoursePaymentSuccess = () => {
    setCoursePaymentVisible(false)
    queryProject()
    queryMenu(projectId, false, (menuData) => {
      const nextTask = pickTaskAfterPayment(menuData)
      if (nextTask) {
        chapterId = parseInt(String(nextTask.chapterId))
        taskId.current = parseInt(String(nextTask.taskId))
        setTheChapterId(chapterId)
      }
      queryTaskInfo(shouldUseTeacherMode())
      queryUserTaskNote()
      setCurrentActiveTabKey('1')
      setCurrentOutputActiveTabKey('outputs')
      setPendingAccessInfo(null)
    })
  }

  const editorOptions = {
    selectOnLineNumbers: true,
    fontSize: 16,
    minimap: { enabled: false },
    lineDecorationsWidth: 5,
    lineNumbersMinChars: 2,
    quickSuggestions: true,
    automaticLayout: true, // 拖拽分屏线时自适应宽度
    hover: { enabled: false },
    renderLineHighlight: 'none' as const,
  }




  /** 用户笔记变化 */
  const onEditMDChange = (value: any) => {
    setNotes(value.text)
  }




  const onMenuDrawerClose = (e: any) => {
    e.preventDefault()
    setMenuVisible(false)
    setMenuSelected(false)
  }

  const handleTaskSelected = (selectedKeys: any, object: any) => {
    //处理通过大纲菜单选择了某一个任务事件
    if (selectedKeys[0]?.split('_')?.length > 1) {
      if (object?.node?.pay_locked == 1) {
        showAccessGuide({
          access_info: courseAccessInfo || project?.access_info || {},
          target_task_id: selectedKeys[0].split('_')[1],
          target_chapter_id: object?.node?.chapterId,
        })
        return
      }
      taskId.current = selectedKeys[0].split('_')[1]
      const newChapterId = object.node.chapterId
      if (newChapterId) chapterId = newChapterId
      queryTaskInfo(shouldUseTeacherMode())
      queryUserTaskNote()
      setMenuVisible(false) //关闭大纲选择框
      setMenuSelected(false)

      setCurrentActiveTabKey("1")//显示任务描述
      setCurrentOutputActiveTabKey("outputs") //输出结果默认显示 运行结果
      try {
        let tab_panels = document.querySelectorAll("div[role='tabpanel']")
        for(let tab_panel_ind in tab_panels){
          tab_panels[tab_panel_ind].scrollTop = 0
        }
      }catch(error){

      }

      refresh_table_tds()

    }
  }

  // 习题提交回调
  const runCodeCallback = (submitMode: number, response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
    } else if (response.code == 0) {

      // 是当前任务的结果才保存
      if(response.exercise_id == taskId.current){
        setTaskStatus(100)//
        // 成功
        setOutputHeight(300)
        setSubmitImages(response.data.images)
        setIsAnimation(response.data.is_animation)
        setVariables(response.data.variables)
        setSubmitTime(response.data.history_submit_time)
        if (response.data.is_html) {
          setOutputs('')
          setUserImage(response.data.output)
          setUserImageJs(response.data.js_script)
          try{ eval(response.data.js_script)} catch (e) {
            console.log("great",e)
          }
          
        } else if (response.data.is_animation) {
          clearInterval(animationTimer.current)
          let imgs = response.data.images
          let n = 0
          animationTimer.current = setInterval(function () {
   
            let imgContain: any =
              document.getElementById('animation_img') &&
              document.getElementById('animation_img')
            if (imgContain) {
              imgContain.src = 'data:image/jpg;base64,' + imgs[n]
              n = n + 1
              if (n >= imgs.length) {
                n = 0
              }
            }
          }, 100)
        } else {
          setOutputs(response.data.output)
        }
        setIsHtml(response.data.is_html)
        if (response.data.status == true) {
          // 同步请求
          setCurrentStatus(true)
          submitMode == 2 ? setRunning(false) : setTestRunning(false)
        } else {
          if (response.data.need_sleep) {
            // 处理spark 异步请求
            let renderResult = false
            let _params = {
              exercise_id: taskId.current,
              sessionid: Cookies.get('sessionid'),
            }
            if (checkIsTeacher()) {
              _params['mode'] = 2
            }

            let increment = 0 // 增量，倒计时 = 0;
            // 定时查询执行结果
            let interval = setInterval(() => {
              increment += 1
              sendHttpPostRequest(
                'exercise/api/query_task_by_id/',
                _params,
                (response: any) => {
                  let submission_status =
                    response.exercise_info.submission_info.submission_status
                  setTaskStatus(submission_status)
                  if (submission_status !== 1) {
                    clearInterval(interval)
                    clearInterval(checkStatusTimer.current)
                    setRunning(false)
                    setTestRunning(false)
                  }
                  if (
                    response.exercise_info.submission_info.submission_status == 2
                  ) {
                    renderResult = true
                    clearInterval(interval)
                    clearInterval(checkStatusTimer.current)
                    increment = 0

                    setVariables(
                      response.exercise_info.submission_info.submission_variables
                    )
                    setCurrentStatus(true)
                    setIsAnimation(
                      response.exercise_info.submission_info.is_animation
                    )
                    setSubmitImages(
                      response.exercise_info.submission_info.submission_image
                    )

                    if (response.exercise_info.submission_info.is_html) {
                      setOutputs('')
                      setUserImage(
                        response.exercise_info.submission_info.submission_output
                      )
                      setUserImageJs(
                        response.exercise_info.submission_info.js_script
                      )
                      eval(response.exercise_info.submission_info.js_script)
                    } else if (
                      response.exercise_info.submission_info.submission_output &&
                      response.exercise_info.submission_info.submission_output !=
                        '' &&
                      response.exercise_info.submission_info.submission_output.indexOf(
                        '+--'
                      ) >= 0 &&
                      response.exercise_info.submission_info.submission_output.lastIndexOf(
                        '--+'
                      ) >= 0
                    ) {
                      specialTreatment.current = true
                      if (
                        response.exercise_info.submission_info.submission_output
                      ) {
                        setUserImage('')
                        setUserImageJs('')
                        specialTreatmentfun(
                          response.exercise_info.submission_info.submission_output
                        )
                      }
                    } else {
                      specialTreatment.current = false
                      setOutputs(
                        response.exercise_info.submission_info.submission_output
                      )
                    }
                    setIsHtml(response.exercise_info.submission_info.is_html)

                    submitMode == 2 ? setRunning(false) : setTestRunning(false)

                    return
                  } else if (
                    response.exercise_info.submission_info.submission_status == 3
                  ) {
                    if (
                      response.exercise_info.submission_info.submission_output &&
                      response.exercise_info.submission_info.submission_output !=
                        '' &&
                      response.exercise_info.submission_info.submission_output.indexOf(
                        '+--'
                      ) >= 0 &&
                      response.exercise_info.submission_info.submission_output.lastIndexOf(
                        '--+'
                      ) >= 0
                    ) {
                      specialTreatment.current = true
                      setUserImage('')
                      setUserImageJs('')
                      specialTreatmentfun(
                        response.exercise_info.submission_info.submission_output
                      )
                    } else {
                      specialTreatment.current = false
                    }
                    renderResult = true
                    clearInterval(interval)
                    clearInterval(checkStatusTimer.current)

                    increment = 0

                    setOutputs(
                      response.exercise_info.submission_info.submission_output
                    )
                    setVariables(
                      response.exercise_info.submission_info.submission_variables
                    )
                    setCurrentStatus(false)
                    submitMode == 2 ? setRunning(false) : setTestRunning(false)

                    return
                    // }
                  }
                }
              )
            }, 5000) // 定时器
          } else {
            // 其他情况
            setOutputs(response.data.output)
            setVariables(response.data.variables)
            setCurrentStatus(false)
            submitMode == 2 ? setRunning(false) : setTestRunning(false)
          }
        }
      }

    } else if (response.code == -501) {
      message.error(response.message)
      // 权限不足
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
      clearInterval(checkStatusTimer.current)
    } else if (response.code == -1) {
      message.error(response.message)
      setCurrentStatus(false)
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
      clearInterval(checkStatusTimer.current)
    } else {
      message.error(response.message)
      setCurrentStatus(false)
      submitMode == 2 ? setRunning(false) : setTestRunning(false)
      clearInterval(checkStatusTimer.current)
    }
  }

  /**
   * 点击了运行、提交按钮
   * @param submitMode 1: 测试  2: 提交
   */
  const exerciseSubmitBtnClick = (_submitMode: number) => {
    sendHttpPostRequest(
      'exercise/api/create_submit_info',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        exercise_id: taskId.current,
        chapter_id: chapterId,
        college_id: collegeId,
        run_type: _submitMode,
        task_number: getChapterTaskIndByTaskId(taskId.current),
      },
      (res) => {
        if (res.code == -2) {
          setMultipleRunModalVis(true)
          return
        } else if (res.code == 0) {
          if (animationTimer.current) {
            clearInterval(animationTimer.current)
          }
          setCurrentStatus(null as any)
          setSubmitMode(_submitMode)
          setUserImage('')
          setUserImageJs('')
          setOutputs('')
          setSubmitImages([] as any)
          _submitMode == 2 ? setRunning(true) : setTestRunning(true)
          let exerciseSubmitId = res.data.exercise_submit_id
          checkStatusTimer.current = setInterval(() => {
            checkRunningStatus(res.data.exercise_submit_id)
          }, 1000)
          sendHttpPostRequest(
            'exercise/api/exercise_run/',
            {
              sessionid: Cookies.get('sessionid'),
              sid: Cookies.get('sessionid'),
              exercise_id: taskId.current,
              chapter_id: chapterId,
              code: userCode,
              submit_mode: _submitMode,
              project_id: projectId,
              lecture_id: taskId.current,
              college_id: collegeId,
              exercise_submit_id: exerciseSubmitId,
            },
            runCodeCallback.bind(this, _submitMode)
          )
        } else {
          message.error(res.msg)
        }
      }
    )
  }


    /**
   * 复制
   * @param objectId: 被复制的元素唯一标识符
   */
    const copyContent = (objectId) => {
      const copyEle = document.querySelector('#' + objectId) // 获取要复制的节点
      const range = document.createRange() // 创造range
      window.getSelection().removeAllRanges() //清除页面中已有的selection
      range.selectNode(copyEle) // 选中需要复制的节点
      window.getSelection().addRange(range) // 执行选中元素
      const copyStatus = document.execCommand('Copy') // 执行copy操作
      // 对成功与否定进行提示
      if (copyStatus) {
        message.success('复制成功')
      } else {
        message.error('复制失败')
      }
      window.getSelection().removeAllRanges() //清除页面中已有的selection
    }

  // 编辑器挂载后保存实例引用，并清除初始选区
  const editorDidMount = (editor: any) => {
    monacoEditorRef.current = editor
    setTimeout(() => {
      editor.setSelection({ startLineNumber: 1, startColumn: 1, endLineNumber: 1, endColumn: 1 })
    }, 0)
  }

  // 标记是否是用户编辑导致的代码变化
  const isUserEditingRef = useRef(false)

  // userCode 变化时清除选区（仅在非用户编辑时，如加载任务/重置代码）
  useEffect(() => {
    if (monacoEditorRef.current && !isUserEditingRef.current) {
      setTimeout(() => {
        (monacoEditorRef.current as any).setSelection({ startLineNumber: 1, startColumn: 1, endLineNumber: 1, endColumn: 1 })
      }, 0)
    }
    isUserEditingRef.current = false
  }, [userCode])

  //用户编辑代码发生改变
  const onUserCodeChange = (newValue, e) => {
    isUserEditingRef.current = true
    setUserCode(newValue)
  }



  /** 任务状态和颜色的映射 */
  const getColorByStatus = (status: number) => {
    if (status == 0) {
      return '#f2f2f2'
    } else if (status == 1) {
      return '#9a3232'
    } else {
      return '#4f46e5'
    }
  }

  /** 答题状态和题号颜色的映射 */
  const getFontColorByStatus = (status: number) => {
    if (status == 0) {
      return '#4f46e5'
    } else {
      return '#fff'
    }
  }

  const projectStatusContent = (
    <div style={{ padding: 10, }}>
      <Row
        justify="end"
        align="middle"
        gutter={[8, 8]}
        style={{ marginBottom: 10 }}
      >
        <Col>
          <div
            style={{
              fontSize: 12,
              height: 12,
              width: 12,
              backgroundColor: '#4f46e5',
            }}
          ></div>
        </Col>
        <Col style={{ fontSize: 12 }}>通过 {correctTaskNum} </Col>
        <Col>
          <div style={{ height: 12, width: 12, background: '#9a3232' }}></div>
        </Col>

        <Col style={{ fontSize: 12 }}>未通过 {wrongTaskNum} </Col>
        <Col>
          <div style={{ height: 12, width: 12, background: '#f2f2f2' }}></div>
        </Col>

        <Col style={{ fontSize: 12 }}>未提交 {unsubmitTaskNum} </Col>
      </Row>
      <div style={{ marginTop: -30 }}>
        {menu?.map((chapter: any, index: number) => (
          <>
            <Row
              style={{ marginTop: 10, marginBottom: 10, fontSize: 14 }}
              gutter={[8, 8]}
            >
              <Col>
                <div
                  style={{
                    textAlign: 'center',
                    borderRadius: 12,
                    height: 24,
                    width: 24,
                    color:'#fff',
                    backgroundColor: 'rgb(59, 109, 116)',
                  }}
                >
                  {' '}
                  {chapter.is_pass == 0 ? (
                    <LockOutlined />
                  ) : (
                    getChapterLabels(index)
                  )}{' '}
                </div>
              </Col>

              <Col style={{fontWeight:500,fontSize:16}}>{chapter.name}</Col>
            </Row>
            <Row
              align="middle"
              justify={'start'}
              gutter={[2, 2]}
              style={{ textAlign: 'left', width: '100%' }}
            >
              {chapter?.tasks?.map((task: any, taskInd: number) => (
                <Col key={index}>
                  <a
                    style={{ color: getFontColorByStatus(task.status) }}
                    href={`/task_learn?project/${projectId}/chapter/${chapter.id}/task/${task.id}/`}
                  >
                    <div
                      style={{
                        backgroundColor: getColorByStatus(task.status),
                        color: getFontColorByStatus(task.status),
                        margin: 5,
                        padding: 'auto',
                        textAlign: 'center',
                        height: 24,
                        lineHeight: '24px',
                        width: 24,
                        fontSize: 12,
                        borderRadius: 2,
                        cursor: 'pointer',
                      }}
                    >
                      {taskInd + 1}
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </>
        ))}
      </div>
    </div>
  )


  const MenuItem = (props: any) => {
    const { dataset, onClick, index } = props

    return (
      <Row
        onClick={onClick}
        className={
          taskLearnStyles.menuItem +
          ' ' +
          (dataset.dataset_id == activeMountedDatasetInfo?.dataset_id ||
          dataset.dataset_id == activeMountedDatasetInfo?.id
            ? taskLearnStyles.activeMenuItem
            : '')
        }
        align={'top'}
        justify={'space-between'}
        
      >
        <Col>
          <Row align={'top'} justify={'start'} style={{ gap: '10px' }} wrap={false}>
            <Col>
              <span
                style={{
                  color: '#4f46e5',
                }}
                className="iconfont icon-datafull"
              ></span>
            </Col>
            <Col>
              <div
                className={taskLearnStyles.dtstTitle + ' ' + GlobalCss.oneLineTextOverflow}
                style={{ maxWidth: '250px' }}
              >
                {dataset.title}
              </div>

            </Col>
          </Row>
          
        </Col>

        <Col span={24}>             
         <CopyToClipboard
                text={'../' + dataset?.base_path}
                onCopy={() => {
                  message.success('路径已复制')
                }}
              >
                <div className={taskLearnStyles.dtstTitle + ' ' + GlobalCss.oneLineTextOverflow} style={{ maxWidth: '290px' }}>
                  {dataset?.base_path}
                </div>
              </CopyToClipboard>
        </Col>
      </Row>
    )
  }


  const queryMountedDatasetInfo = (id) => {
    let data = {
      dataset_id: id,
    }
    sendHttpPostRequest('dataset/api/user_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setActiveMountedDatasetInfo({
          ...res.query_info,
          dataset_id: res.query_info.id,
        })
      } else {
        message.error(res.message)
      }
    })
  }


  const onMenuClick = (dataset) => {
    queryMountedDatasetInfo(dataset?.dataset_id)
  }

  const taskDatasetContent = (
    <div style={{ padding: 10, backgroundColor: 'transparent' }} >
        <Tabs
            activeKey={datasetActiveTabKey}
            onChange={(key) => {
              if (key == 'mounteddata') {
                setActiveMountedDatasetInfo(task?.mounted_datasets[0])
              }
              setDatasetActiveTabKey(key)
      
            }}
          >
            <Tabs.TabPane tab={<span><TableOutlined style={{marginRight: 5}} />任务数据</span>} key="taskdata" >
              {taskDatasetInfo && (
                <FileList
                  actionPath={'/user_task_edit?task_id=' + taskId} // 该参数不影响结果
                  datasetInfo={taskDatasetInfo}
                  source='user'
                  dataset_id={taskDatasetInfo?.id}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<span><DatabaseOutlined style={{marginRight: 5}} />挂载数据</span>} key="mounteddata" >
              {task?.mounted_datasets?.length > 0 ? (
                <Row className={taskLearnStyles.montedContain} wrap={false}>
                  <Col className={taskLearnStyles.montedMenu} flex={'290px'}>
                    {task?.mounted_datasets?.map((dtst, i) => {
                      return (
                        <MenuItem
                          key={dtst.dataset_id}
                          dataset={dtst}
                          onClick={onMenuClick.bind(this, dtst)}
                          index={i}
                        />
                      )
                    })}
                  </Col>
                  <Col className={taskLearnStyles.montedTable} flex={'auto'}>
                    {activeMountedDatasetInfo && (
                      <FileList
                        actionPath={'/user_task_edit?task_id=' + exerciseId} // 该参数不影响结果
                        datasetInfo={activeMountedDatasetInfo}
                        //intFilePath={[] as any}
                        mode={'monted'}
                        source='user'
                        dataset_id={activeMountedDatasetInfo?.dataset_id}
                      />
                    )}
                  </Col>
                </Row>
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '500px',
                    lineHeight: '500px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <span style={{ color: '#999999' }}>
                        暂无数据
                      </span>
                    }
                  />
                </div>
              )}
            </Tabs.TabPane>

          </Tabs>
    </div>
  )



  const nextTaskBtn = () => {

    // 获取目标div元素
    //const myDiv = document.getElementById("editorWrapper");
    //myDiv.click()
    // 添加点击事件监听器
    //myDiv.addEventListener("click", function () {
    //alert("您点击了div标签！");
    //});

    //window.getSelection().removeAllRanges() 
    setCurrentStatus(null as any)
    setTaskStatus(100)
    sendHttpPostRequest(
      'course/api/exe_next',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: project.id,
        chapter_id: theChapterId,
        exercise_id: taskId.current,
      },
      nextTaskBtnCallback
    )
    setCurrentActiveTabKey("1")//显示任务描述
    setCurrentOutputActiveTabKey("outputs") //输出结果默认显示 运行结果
      try {
        let tab_panels = document.querySelectorAll("div[role='tabpanel']")
        for(let tab_panel_ind in tab_panels){
          tab_panels[tab_panel_ind].scrollTop = 0
        }
      }catch(error){
        
      }

      refresh_table_tds()
  }

  /**
   * 点击了下一个任务回调
   * @param response
   */
  const nextTaskBtnCallback = (response: any) => {

    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == -4201) {
      showAccessGuide(response)
    } else if (response.is_ok == true) {
      //window.getSelection().removeAllRanges() 
      setDatasetActiveTabKey('taskdata')
      clearInterval(checkStatusTimer.current)
      clearInterval(timer)
      if (response.is_pass == 1) {
        chapterId = parseInt(response.chapter_id)
        console.log(response.chapter_id)
        
        taskId.current = parseInt(response.exercise_id)
        queryTaskInfo(shouldUseTeacherMode())
        queryUserTaskNote()
      } else {
        message.error('尚未解锁，请完成当前解锁的所有任务再试~')
      }
    } else {
      message.error(response.message)
    }
  }

  const preTaskBtn = () => {
    setCurrentStatus(null as any)
    setTaskStatus(100)
    sendHttpPostRequest(
      'course/api/exe_prew',
      {
        sessionid: Cookies.get('sessionid'),

        course_id: project.id,
        chapter_id: theChapterId,
        exercise_id: taskId.current,
      },
      preTaskBtnCallback
    )
    setCurrentActiveTabKey("1")//显示任务描述
    setCurrentOutputActiveTabKey("outputs") //输出结果默认显示 运行结果
    try {
      let tab_panels = document.querySelectorAll("div[role='tabpanel']")
      for(let tab_panel_ind in tab_panels){
        tab_panels[tab_panel_ind].scrollTop = 0
      }
    }catch(error){
      
    }

    refresh_table_tds()
  }

  /**
   * 上个任务回调
   * @param response
   */
  const preTaskBtnCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == -4201) {
      showAccessGuide(response)
    } else if (response.is_ok == true) {
      //window.getSelection().removeAllRanges() 
      setDatasetActiveTabKey('taskdata')
      clearInterval(checkStatusTimer.current)
      clearInterval(timer)

      if (response.is_pass == 1) {
        chapterId = parseInt(response.chapter_id)
        taskId.current = parseInt(response.exercise_id)
        queryTaskInfo(shouldUseTeacherMode())
        queryUserTaskNote()

      } else {
        message.error('尚未解锁，请完成当前解锁的所有任务再试~')
      }
    } else {
      message.error(response.message)
    }
  }

  const [valueContentOpen, setValueContentOpen] = useState(true)
  const openValueContent = () => {
    {
      valueContentOpen ? setValueContentOpen(false) : setValueContentOpen(true)
    }
  }


  const renderValue = (value: any, record: any) => {
    if (value.length > 35) {
      return (
        <div key={record.var}>
          <div
            style={{
              //color: '#f2f2f2',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {valueContentOpen
              ? value.slice(0, 35).replaceAll('\n', '<br/>')
              : value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
    } else
      return (
        <div key={record.var}>
          <div
            style={{
              //color: '#f2f2f2',
              marginLeft: 20,
              marginRight: 20,
              marginBottom: 10,
              paddingTop: 0,
              borderRadius: 5,
            }}
          >
            {value.replaceAll('\n', '<br/>')}
          </div>
        </div>
      )
  }

  const variableColumns: any = [
    {
      title: '变量',
      dataIndex: 'var',
      key: 'var',
      align: 'left',
      width: 60,
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      align: 'left',
      width: 60,
    },

    {
      title: (
        <div>
          取值{' '}
          <Button
            onClick={openValueContent}
            className={taskLearnStyles.openBtn}
            style={{ float: 'right', marginLeft: 5 }}
          >
            {valueContentOpen ? (
              <span>
                展开
                <DownOutlined style={{ marginLeft: 5 }} />
              </span>
            ) : (
              <span>
                收起
                <UpOutlined style={{ marginLeft: 5 }} />
              </span>
            )}
          </Button>
        </div>
      ),
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      width: 100,
      render: renderValue,
    },
  ]


  /** 从项目大纲中查找章和节索引 */
  const getChapterTaskIndByTaskId = (taskId) => {
    let result = { chapterInd: -1, taskInd: -1, taskName: '' }
    menu?.map((chapter, chapterInd) => {
      chapter?.tasks.map((item, itemInd) => {
        if (item.id == taskId) {
          result.chapterInd = chapterInd
          result.taskInd = itemInd
          result.taskName = item.name
        }
      })
    })
    return result.chapterInd + 1 + '.' + (result.taskInd + 1)
  }

 
    return (
      <Layout className="task-learn-page">

        <div className={taskLearnStyles.headerDiv}> 
          <Row wrap={false} align={'middle'} style={{width:'100%'}}>

            <Col flex={"60px"}>
              <div>
                  <img
                  key={'0'}
                  id={'menu-0'}
                  title=""
                  alt="logo"
                  src={logoIconSvg}
                  height={36}
                ></img>
              </div>
            </Col>
            <Col flex={"auto"} style={{textAlign:'left'}}>
              <div style={{fontSize:20, fontWeight:600, color:'#fff', cursor:'pointer', letterSpacing:'0.5px'}}                 
              onClick={() => {
                  window.location.href =
                    collegeInfo?.is_college_teacher == 1
                      ? '/project_main?project_id=' + projectId
                      : '/project_main_student?project_id=' + projectId
                }}>
                  {project?.name} 

                  
              </div>
            </Col>

            <Col flex={"400px"} style={{textAlign:'right'}}>
              <div>

                  { task?.have_dataset == true  && 
                    <span className={taskLearnStyles.topButtonWrapper} style={{marginRight:12}}>
                      <Popover
                          overlayClassName={taskLearnStyles.taskDatasetWrapper }
                          //style={{width:500}}
                          arrowPointAtCenter={true}
                          placement="bottom"
                          //open={true}
                          trigger='click'
                          content={taskDatasetContent}
                          title="任务数据"
                          onOpenChange = {(open: boolean) => {setDatasetContentVisible(open)}}
                        >
           
                          <Icon component={mydatasetIcon}/> 
                          
                      </Popover>
                    </span>

                   }


                    <span className={taskLearnStyles.topButtonWrapper} style={{marginRight:12}}>
                      <Popover
                          overlayClassName={taskLearnStyles.popoverWrapper }
                          arrowPointAtCenter={true}
                          //open={projectStatusContentVisible}
                          placement="bottom"
                          trigger='click'
                          content={getMenuTreeContent()}
                          title="任务目录"
                          onOpenChange = {(open: boolean) => { if (open == true){queryMenu(projectId, false)}}}
                        >

                           <Icon component={mymenuIcon}/> 
                        </Popover>
                    </span>


                    <span className={taskLearnStyles.topButtonWrapper}>
                        <UserInfo></UserInfo>
                    </span>

                    


              </div>
            </Col>

          </Row>
        </div>

        <TSplitPane
          allowResize={true}
          split="vertical"
          defaultSize={'50%'}
          primary="second"
          maxSize={-300}
        >


          <div
            className={taskLearnStyles.setting}
            style={{ position: 'relative' }}
          >
            <div
              style={{
                height: 40,
                position: 'absolute',
                width: 5,
                top: 0,
                left: -5,
                //backgroundColor: '#1e1b4b',
                zIndex: 10,
              }}
            ></div>



            <Tabs
              activeKey={currentActiveTabKey}
              onChange={(activeKey: any) => {
                setCurrentActiveTabKey(activeKey)
              }}
              
              type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane
                style={{  paddingBottom: 0 }}
                tab={
                  <div style={{ whiteSpace:'nowrap', fontSize: 14, fontWeight: 500}}>
                    <Icon component={mydescriptionIcon}/>  任务描述
                  </div>
                }
  
                key="1"
              >
                {task?.video && task?.video !== '' && (
                  <div style={{ background: '#000000' }}>
                    <video
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        height: 250,
                        width: '100%',
                      }}
                      preload="preload"
                      controls={true}
                      controlsList="nodownload"
                    >
                      <source src={task?.video} type={'video/mp4'} />
                      您的浏览器不支持 HTML5 video 标签。
                    </video>
                  </div>
                )}

                <div id="task_desp">
                  <ReactMarkdown
                    className={taskLearnStyles.reactmarkdown}
                    remarkPlugins={[gfm, remarkMath]}
                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                  >
                    {task?.steps}
                  </ReactMarkdown>
                </div>

                {task?.images && task?.images?.length > 0 && (
                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <ConfigProvider locale={zhCN}>
                      {task?.images?.map((image: any, imageInd: number) => {
                        return (
                          <Row
                            key={image.name}
                            wrap={false}
                            justify="center"
                            align="middle"
                            style={{ marginTop: 10, marginBottom: 10 }}
                          >
                            <Col
                              span={24}
                              style={{
                                //width: '100%',
                                //maxWidth: 500,
                                textAlign: 'center',
                              }}
                            >
                              <div className={taskLearnStyles.previewImageWrap}>
                                <Image
                                  style={{
                                    backgroundColor: '#f2f2f2',
                                    borderRadius: 3,
                                    maxHeight:500
                                  }}
                                  preview={false}
                                  src={
                                    constants.BACKEND_URL +
                                    image.path +
                                    image.name
                                  }
                                />
                              </div>

                              <div style={{ marginTop: 5 }}>
                                图{imageInd + 1}
                              </div>
                            </Col>
                          </Row>
                        )
                      })}
                    </ConfigProvider>
                  </div>
                )}

                { task?.type !== 6 && 
                  <div className={taskLearnStyles.taskSteps}>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: '#1e293b',
                        margin:'0 0 24px',
                        padding:'0 0 16px',
                        borderBottom:'1px solid #f1f5f9'
                      }}
                    >
                      <span className={taskLearnStyles.mystepsIconWrapper}> <Icon component={mystepsIcon}/> </span>  任务步骤
                    </div>
                    <ReactMarkdown
                      className={taskLearnStyles.reactmarkdownTaskSteps}
                      remarkPlugins={[gfm, remarkMath]}
                      rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                    >
                      {task?.task_steps}
                    </ReactMarkdown>
                  </div>
                }

                {task?.task_conclude && task?.task_conclude !== '' && (
                  <div id="task_conclude">
                    <ReactMarkdown
                      className={taskLearnStyles.reactmarkdown}
                      remarkPlugins={[gfm, remarkMath]}
                      rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                    >
                      {task?.task_conclude}
                    </ReactMarkdown>
                  </div>
                )}

                <div id="tab_desp_bottom" style={{ height: 50 }}></div>
              </TabPane>
              {task?.type !== 6 && (
              <TabPane
                style={{
                  position: 'relative',
                }}
                tab={
                  <div style={{ whiteSpace:'nowrap', fontSize: 14, fontWeight: 500  }}>
                    <Icon component={mynoteIcon}/> 
                    任务笔记
                  </div>
                }
                key="2"
              >
 
                {noteEditMode && (
                  <div className={taskLearnStyles.mdtextareatasknotes}>
                    <MarkDownEditor
                      preview={false}
                      //height={700}
                      placeholder="在此输入你的实训笔记...可以记录实训任务的关键参数和配置、实验结果、思考过程等"
                      onChange={onEditMDChange}
                      value={notes}
                      // uploadOption={uploadOption}
                      toolbar={'note'}
                      onBlur={() => save_note()}
                    />
                  </div>
                )}

              

              </TabPane> )
              }

              {task?.reference_answer  && task?.type !== 6 && (
                <TabPane
                  style={{ paddingTop: 16 }}
                  tab={
                    <div
                      style={{ whiteSpace:'nowrap', fontSize: 14, fontWeight: 500 }}
                    >
                      <Icon component={mylightIcon}/>  任务答案
                    </div>
                  }
                  key="3"
                >

                  <div style={{color:'#92400e', fontSize:14, fontWeight:500, margin:'0 0 24px', borderLeft:'3px solid #f59e0b', borderRadius:'0 8px 8px 0', padding:'12px 16px', background:'linear-gradient(135deg, #fffbeb, #fef3c7)', boxShadow:'0 1px 4px rgba(245,158,11,0.1)', display:'flex', alignItems:'center', gap:8 }}>
                        <InfoCircleOutlined style={{fontSize:16, color:'#d97706', flexShrink:0}} /> <span>建议先尝试自己完成任务，遇到困难时再查看答案作为参考。</span>
                  </div>
                  <div
                    
                    style={{borderRadius:12, padding:20, border:'1px solid #e5e7eb', background:'#fafafa'}}
                  >
                    
                    <Row wrap={false} align={'middle'}>
                      <Col span={12} style={{textAlign:'left'}}>
                        <div style={{color:'#4f46e5', fontSize:18, fontWeight:500, margin:'0 0 12px'}}>参考答案</div>
                      </Col>

                      <Col span={12} style={{textAlign:'right'}}>
                        <div>
                        <span
                            id="next-page-icon-btn"
                            onClick={copyContent.bind(this,'taskAnswerText')}
                            className={taskLearnStyles.nextTaskSpan}
                            style={{marginRight:0,fontSize:14, padding:'6px 12px'}}
                          >
                            <Icon component={myCopyIcon}/>  复制代码
                          </span>
                        </div>
                      </Col>

                    </Row>

                    <div id='taskAnswerText'>
                      <ReactMarkdown
                        
                        className={taskLearnStyles.reactmarkdown}
                        remarkPlugins={[gfm, remarkMath]}
                        rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                      >
                        {"```python\n" + task?.reference_answer + "\n```"}
                      </ReactMarkdown>
                    </div>
                  </div>
                </TabPane>
              )}
            </Tabs>
          </div>

           <div style={{ height: 'calc(100vh - 145px)', backgroundColor: '#0f172a' }}>
            <TSplitPane
              maxSize={-90}
              style={{ height: 'calc(100vh - 145px)' }}
              onChange={onVerticalPane1Change}
              allowResize={true}
              split="horizontal"
              defaultSize={'50%'}
              pane2Style={{ maxHeight: '100%' }}
            >
              <div
                className={taskLearnStyles.userCode}
                style={{ width: '100%' }}
              >
                <div style={{zIndex: 20 }}>
                  <Row
                    wrap={false}
                    style={{ padding:12 , background:'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', borderBottom:'1px solid rgba(99,102,241,0.15)'}}
                    justify="start"
                    align="middle"
                    gutter={8}
                  >


                    <Col flex="auto">
                      <Row
                        wrap={false}
                        
                        justify="center"
                        align="middle"
                        gutter={[0, 0]}
                      >

                        <Col  flex="auto">
                          {' '}
                          <div
                            style={{
                              whiteSpace:'nowrap',
                              textOverflow:'ellipsis',
                              overflow: 'hidden',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#e2e8f0',
                              fontSize:20
                            }}
                          >
                            {getChapterTaskIndByTaskId(task?.id)} {task?.title}{' '}
                          </div>
                        </Col>

                      <Col flex={"50px"} style={{ textAlign: 'center' }}>
                        <span className={taskLearnStyles.reportBtnWrapper}>
                          {checkTaskInRepot(taskId.current) == true ? (
                            <Tooltip
                              placement="top"
                              title={'本任务结果同步到项目报告'}
                            >
                              <Icon component={myreportIcon}/> 
                            </Tooltip>
                          ) : (
                            ''
                          )}
                        </span>
                      </Col>

                        <Col  flex="120px">
                        
                          <span
                            id="before-page-icon-btn"
                            onClick={() => {
                              if (!isFirstTask) preTaskBtn()
                            }}
                            className={`${taskLearnStyles.preTaskSpan} ${isFirstTask ? taskLearnStyles.preTaskSpanDisabled : ''}`}
                          >
                              <Icon component={myarrowleftIcon}/> 上一个
                          </span>
                        </Col>

                        <Col  flex="120px">
                          
                          <span
                            id="next-page-icon-btn"
                            onClick={() => {
                              if (!isLastTask) nextTaskBtn()
                            }}
                            className={`${taskLearnStyles.nextTaskSpan} ${isLastTask ? taskLearnStyles.nextTaskSpanDisabled : ''}`}
                          >
                            下一个 <Icon component={myarrowrightIcon}/> 
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

              <div id="editorWrapper"  style={{height:'100%', width:'100%'}}>
                  {
                  task?.type !== 6 ? 
                  <MonacoEditor                    
                    width="100%"
                    language="python"
                    theme={'vs-dark'}
                    value={userCode}
                    //value={testCode}
                    options={editorOptions}
                    onChange={onUserCodeChange}
                    editorDidMount={editorDidMount}
                /> :<div style={{fontSize:18,paddingBottom:64,alignItems: 'center', display:'flex', justifyContent: 'center',  height:'100%', color:'#94a3b8', background:'#0f172a'}}>
                    <InfoCircleOutlined style={{marginRight:5}} /> 本任务无需编码
                  </div>}
                </div>
              
                
              </div>

              <div
                className={taskLearnStyles.outputResultWrapper}
                id="running-ouput-wrapper"
                style={{ width: '100%' }}
              >
                <Tabs 
                    //hidden={!(!running && !testRunning)}                
                    activeKey={currentOutputActiveTabKey}
                  onChange={(activeKey: any) => {
                    setCurrentOutputActiveTabKey(activeKey)
                  }}
              type="card">
                  <TabPane
                    tab={<div> <CodeOutlined /> 运行结果 </div>}
                    key="outputs"
                    style={{
                      overflow: 'auto',
                      height: outputIsFullScreen
                        ? `calc(100vh - ${70}px)`
                        : `calc(100vh - ${verticalPane1Height + 202}px)`,
                    }}
                  >
                    {
                        (running || testRunning || stoping) &&
                    <div style={{alignItems: 'center', display:'flex', justifyContent: 'center',  height:'100%',}}>
                      {!(!running && !testRunning) && (
                          <div
                            style={{
                              height:'100%',
                              width:'100%',
                              alignItems: 'center', display:'flex', justifyContent: 'center', 
                              
                              textAlign: 'center',
                              
                            }}
                          >
                            <img height={100} width={100} src={lodingGif}></img>
                          </div>
                        )}

                        {stoping && (
                          <div
                            style={{
                              //position: 'absolute',
                              //left: '50%',
                              //top: '50%',
                              //transform: 'translate(-50%,-50%)',
                              textAlign: 'center',
                            }}
                          >
                            <span
                              style={{ fontSize: '60px', color: '#9A3232' }}
                              className="iconfont icon-dengdai--copy"
                            ></span>
                            <div style={{ marginTop: '24px', color: '#fff' }}>
                              任务正在停止...
                            </div>
                          </div>
                        )}
                    </div>
                    }

                    <div>
                      {outputs  && !specialTreatment.current  && (
                        <ReactMarkdown
                          
                          className={taskLearnStyles.outputRenderMarkdown}
                          //style= {{padding:8,minHeight:200}}
                          remarkPlugins={[gfm, remarkMath]}
                          rehypePlugins={[
                            rehypeHighlight,
                            rehypeKatex,
                            rehypeRaw,
                            
                          ]}
                        >
                          {
                          outputs.replaceAll('\n', '\n\n').replaceAll('```mermaid', '```')
                          }
                        </ReactMarkdown>
                        )}


                      {outputs && specialTreatment.current && (
                        <div
                          className={taskLearnStyles.tbContainer}
                          style={{
                            //color: '#f2f2f2',
                            marginLeft: 20,
                            marginRight: 20,
                            marginBottom: 10,
                            paddingTop: 0,
                            borderRadius: 5,
                            maxWidth:'100%'
                          }}
                          dangerouslySetInnerHTML={{ __html: outputs }}
                        ></div>
                      )}

                      <div>
              
                        {!isAnimation &&
                          submitImages?.map((imageBase64, ind) => {
                            return (
                              <div
                                style={{
                                  backgroundColor: '#fff',
                                  margin: 10,
                                  textAlign: 'center',
                                }}
                                key={String(ind)}
                              >
                                <img 
                                  style={{ backgroundColor: '#fff' , maxWidth:'100%'}}
                                  src={'data:image/jpg;base64,' + imageBase64}
                                ></img>
                              </div>
                            )
                          })}
                        {isAnimation && (
                          <div style={{textAlign:'center'}}>
                            <img 
                              style={{ maxWidth:'100%'}}
                              id="animation_img"
                              src={
                                'data:image/jpg;base64,' + submitImages &&
                                submitImages[0]
                              }
                              alt=""
                            />
                          </div>
                        )}
                      </div>

                      <div
                        id="user-image"
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          overflow: 'auto',
                          backgroundColor: '#fff',
                          maxWidth:'100%',
                        }}
                        className={taskLearnStyles.renderOutputWrapper}

                        dangerouslySetInnerHTML={{
                          __html: userImage?.replaceAll('\n', ''),
                        }}
                      />

                    </div>
                  

                  </TabPane>

                  <TabPane
                    tab={<div> <TableOutlined /> 变量列表 </div>}
                    key="variables"
                    style={{
                      overflow: 'auto',
                      height: outputIsFullScreen
                        ? `calc(100vh - ${70}px)`
                        : `calc(100vh - ${verticalPane1Height + 202}px)`,
                    }}
                  >
                    <div className={taskLearnStyles.variableTableWrapper}>
                      <ConfigProvider locale={zhCN}>
                        <Table
                          dataSource={variables}
                          columns={variableColumns}
                          rowKey={(record) => record.var}
                          pagination={false}
                        />
                      </ConfigProvider>
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </TSplitPane>


      

            <div
              
              style={{
                height: 75,
                borderTop: '1px solid rgba(99,102,241,0.15)',
                padding:'0 16px',
                position: 'absolute',
                bottom: 0,
                width: '100%',
                background:'linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #3730a3 100%)'
              }}
            >
              <Row
                wrap={false}
                justify="start"
                align="middle"
                style={{ height: 75, width: '100%', }}
              >
                <Col span={8} style={{ textAlign: 'left' }}>
                  <Row
                      align="middle"
                      style={{
                        margin: 0,
                        //height: 40,
                        //paddingLeft: 10,
                        //paddingRight: 10,
                      }}
                      gutter={8}
                      wrap={false}
                    >
                      <Col flex={"200px"}>
                        <div style={{width: '100%', color:'#94a3b8', whiteSpace:'nowrap' }}>
                        { running != true &&  submitMode != 1 &&  currentStatus ==true  && taskStatus != 0 && taskStatus != 4  && stoping != true &&
                        <img
                            src={submitSuccessSvg}
                            alt=""
                            style={{ width: 20, height: 20,marginRight:8 }}
                          />
                          }
                          { running != true &&  submitMode != 1 &&  currentStatus == false && taskStatus != 0 && taskStatus != 4  && stoping != true &&
                          <img
                            
                            src={submitFailedSvg}
                            alt=""
                            style={{ width: 20, height: 20,marginRight:8 }}
                          />
                        }

                        {running != true && submitTime && <span>最后运行：{formatTimeToHumanReadable(submitTime)}</span>}
                        </div>
                      </Col>

                    </Row>
                </Col>

                <Col span={16} style={{ textAlign: 'right', whiteSpace:'nowrap'}}>

                  <span className={taskLearnStyles.reundoIcon}
                       onClick={() => { if (task?.type !== 6) {setUserCode(task?.default_code)}  }}
                  >
                    <UndoOutlined /> 重置代码
                  </span>


                  {testRunning ? (
                    <span
                      onClick={() => {
                        setTooltipopen(true)
                      }}
                      className={taskLearnStyles.stopBtn}
                    >
                       <StopOutlined /> 停止
                    </span>
                  ) : (
                    <span
                      id="test-exercise-btn"
                      onClick={ ()=>{ if (task?.type !== 6) {setCurrentOutputActiveTabKey('outputs');exerciseSubmitBtnClick(1)} }}
                      className={taskLearnStyles.testSubmitBtn}
                    >
                     
                      <CaretRightOutlined /> 测 试
                    </span>
                  )}


                  {running ? (
                    <span
                      onClick={() => {
                        setTooltipopen(true)
                      }}
                      className={taskLearnStyles.stopBtn}
                    >
                      <StopOutlined /> 停止
                    </span>
                  ) : (
                    <span
                      id="submit-exercise-btn"
                      onClick={ ()=> {if (task?.type !== 6) { setCurrentOutputActiveTabKey('outputs');exerciseSubmitBtnClick(2)}}}
                      className={taskLearnStyles.submitBtn}

                    >
                      <CheckOutlined style={{marginRight:3}} /> 提 交
                    </span>
                  )}
                </Col>
              </Row>
            </div>
            <TooltipModal
              tooltipopen={tooltipopen}
              setTooltipopen={setTooltipopen}
              mode={'user'}
              onOk={onStopTaskOk}
              content={<p>此任务正在运行中，确定要停止任务吗？</p>}
            />

            <TooltipModal
              tooltipopen={multipleRunModalVis}
              setTooltipopen={setMultipleRunModalVis}
              mode={'user'}
              okText={'提交记录'}
              onOk={checkSubmitRecord}
              content={<p>每个项目最多支持5个任务同时提交，已到上限。</p>}
            />

            <ModalDrag

              modalTitle={'提示'}
              modalContent={
                <Row
                  style={{ height: '135px' }}
                  align={'middle'}
                  justify="center"
                >
                  <Col>{stopedMsg}</Col>
                </Row>
              }
              open={stopedByOtherVis}
              footer={
                <Button
                  onClick={() => {
                    
                    clearInterval(checkStatusTimer.current)
                    setRunning(false)
                    setTestRunning(false)
                    setStopedByOtherVis(false)
                    
                  }}
                  type={'primary'}
                >
                  确定
                </Button>
              }
              onCancel={() => setStopedByOtherVis(false)}
            />



          </div>         
        </TSplitPane>

        <CoursePaymentModal
          visible={coursePaymentVisible}
          courseId={projectId}
          priceCent={pendingAccessInfo?.price_cent}
          onSuccess={onCoursePaymentSuccess}
          onCancel={() => {
            setCoursePaymentVisible(false)
            setPendingAccessInfo(null)
          }}
        />
        <LoginRegisterModal></LoginRegisterModal>
      </Layout>
    )
    

}

export default TaskLearn


